import { ERP } from '../_base/endpoint';
import axios from 'axios';

class ubigeoService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}integracion/ubigeo/Listar`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async departamentos() {
        const response = await axios
            .get(`${ERP}integracion/ubigeo/departamento`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async provincias(idDepartamento) {
        const response = await axios
            .get(`${ERP}integracion/ubigeo/provincia/${idDepartamento}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async distritos(idProvincia) {
        const response = await axios
            .get(`${ERP}integracion/ubigeo/distrito/${idProvincia}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new ubigeoService();